module.exports = __webpack_public_path__ + "static/desktop/img/bp-two.bda9ef27.jpg";